import useMediaQuery from './useMediaQuery';

export default function useCheckIsMobile(maxWidth: number = 768) {
  const isMobile = useMediaQuery(`(max-width: ${maxWidth}px)`);
  return { isMobile };
}
